<template>
  <Breadcrumb></Breadcrumb>
  <CompanyForm :company="company" :title="$gettext('Editer un client')" @submit="onSubmit" @cancel="onCancel"/>
</template>

<script setup>
import { useCompanyStore } from "@/stores/company";
import { useRouter } from "vue-router";
import CompanyForm from "@/components/companies/CompanyForm.vue";
import { onMounted, ref } from "vue";
import Breadcrumb from "@/components/layout/BreadcrumbNavigation.vue";

const router = useRouter();
const companyStore = useCompanyStore();
const company = ref();

const onSubmit = (payload, actions) => {
  companyStore.saveCompany(payload, () => {
    router.push({ name: "company", params: { id: router.currentRoute.value.params.id } });
  }, (errors) => {
    actions.setErrors(errors.value);
  });
};

const onCancel = () => {
  router.back();
};

onMounted(async () => {
  company.value = await companyStore.fetchCompany(router.currentRoute.value.params.id, false, null, [
    "companyDocuments", "companyUltimateBeneficialOwners", "signatories"
  ]);
});

</script>
